(function () {
  var SEARCH_INDEX_SCHEMA_VERSION = 1;
  var AVAILABILITY_PARAM = 'filter.v.availability';
  var LEGACY_AVAILABILITY_PARAM = 'rg_available';
  var VIEW_PARAM = 'rg_view';
  var IMAGE_WIDTHS = [180, 240, 300, 360, 480, 600, 720, 900];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function escapeHtml(value) {
    var span = document.createElement('span');
    span.textContent = value == null ? '' : String(value);
    return span.innerHTML;
  }

  function formatPrice(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: number % 1 === 0 ? 0 : 2,
    }).format(number);
  }

  function parsePrice(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function compareAvailability(a, b) {
    return Number(b.available) - Number(a.available);
  }

  function compareText(a, b, field) {
    return String(a[field] || '').localeCompare(String(b[field] || ''));
  }

  function comparePrice(a, b, direction) {
    var priceA = parsePrice(a.price);
    var priceB = parsePrice(b.price);

    if (priceA == null && priceB == null) return 0;
    if (priceA == null) return 1;
    if (priceB == null) return -1;

    return direction === 'descending' ? priceB - priceA : priceA - priceB;
  }

  function activeParamValues(params, name) {
    return params.getAll(name).filter(Boolean);
  }

  function isHideUnavailableActive(params) {
    return params.get(AVAILABILITY_PARAM) === '1' || params.get(LEGACY_AVAILABILITY_PARAM) === '1';
  }

  function canonicalizeAvailabilityParams(params) {
    var legacyHideUnavailable = params.get(LEGACY_AVAILABILITY_PARAM) === '1';
    params.delete(LEGACY_AVAILABILITY_PARAM);
    if (legacyHideUnavailable && !params.has(AVAILABILITY_PARAM)) {
      params.set(AVAILABILITY_PARAM, '1');
    }
  }

  function filteredFocusedResults(entries, params) {
    var hideUnavailable = isHideUnavailableActive(params);
    var vendors = activeParamValues(params, 'rg_vendor');
    var types = activeParamValues(params, 'rg_product_type');

    return entries.filter(function (entry) {
      if (hideUnavailable && !entry.available) return false;
      if (vendors.length && vendors.indexOf(entry.vendor || '') === -1) return false;
      if (types.length && types.indexOf(entry.product_type || '') === -1) return false;
      return true;
    });
  }

  function sortedValues(entries, field) {
    return Array.from(new Set(entries.map(function (entry) {
      return entry[field] || '';
    }).filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function sortFocusedResults(entries, sortBy) {
    if (!sortBy || sortBy === 'relevance') return entries;

    return entries.map(function (entry, index) {
      return { entry: entry, index: index };
    }).sort(function (a, b) {
      var availableOrder = compareAvailability(a.entry, b.entry);
      if (availableOrder) return availableOrder;

      if (sortBy === 'price-ascending') {
        return comparePrice(a.entry, b.entry, 'ascending') || a.index - b.index;
      }
      if (sortBy === 'price-descending') {
        return comparePrice(a.entry, b.entry, 'descending') || a.index - b.index;
      }
      if (sortBy === 'title-ascending') {
        return compareText(a.entry, b.entry, 'title') || a.index - b.index;
      }
      if (sortBy === 'title-descending') {
        return compareText(b.entry, a.entry, 'title') || a.index - b.index;
      }

      return a.index - b.index;
    }).map(function (item) {
      return item.entry;
    });
  }

  function toggleUrlParam(name, value, active) {
    var url = new URL(window.location.href);
    canonicalizeAvailabilityParams(url.searchParams);
    var values = url.searchParams.getAll(name);
    url.searchParams.delete(name);

    values.forEach(function (currentValue) {
      if (currentValue !== value) url.searchParams.append(name, currentValue);
    });

    if (!active) url.searchParams.append(name, value);
    return url.pathname + url.search;
  }

  function clearFocusedFilterUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete(AVAILABILITY_PARAM);
    url.searchParams.delete(LEGACY_AVAILABILITY_PARAM);
    url.searchParams.delete('rg_vendor');
    url.searchParams.delete('rg_product_type');
    return url.pathname + url.search;
  }

  function isAllView(params) {
    return params.get(VIEW_PARAM) === 'all';
  }

  function allViewUrl() {
    // Focused-only params are dropped so the native view starts clean;
    // the availability param stays because native search understands it.
    var url = new URL(window.location.href);
    canonicalizeAvailabilityParams(url.searchParams);
    url.searchParams.delete('page');
    url.searchParams.delete('rg_vendor');
    url.searchParams.delete('rg_product_type');
    url.searchParams.set(VIEW_PARAM, 'all');
    return url.pathname + url.search;
  }

  function focusedViewUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete(VIEW_PARAM);
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  function nativeResultCount(root) {
    var count = Number(root.dataset.rgNativeCount);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function showAllLinkHtml(nativeCount) {
    return [
      '<a class="rg-search-page__view-all" href="',
      escapeHtml(allViewUrl()),
      '">Show all ',
      nativeCount,
      ' result',
      nativeCount === 1 ? '' : 's',
      '</a>',
    ].join('');
  }

  function renderFilterLink(name, value, label, params) {
    var active = params.getAll(name).indexOf(value) !== -1;

    return [
      '<a class="filter-group__item rg-search-focused-filter__item',
      active ? ' filter-group__item--active' : '',
      '" href="',
      escapeHtml(toggleUrlParam(name, value, active)),
      '" data-rg-search-focused-filter>',
      '<span class="filter-group__item__text">',
      escapeHtml(label),
      '<svg class="filter-tick" role="presentation" viewBox="0 0 20 20"><path d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"></path></svg>',
      '</span>',
      '</a>',
    ].join('');
  }

  function renderFilterGroup(title, html) {
    if (!html) return '';

    // Unique, RG-prefixed target id so ToggleTarget can wire collapse/expand;
    // must not collide with the server-rendered FilterGroup{n}/FilterGroupSort ids.
    var groupId = 'RGSearchFilterGroup-' + title.replace(/[^a-zA-Z0-9]+/g, '-');

    return [
      '<div class="filter-group rg-search-focused-filter__group">',
      '<toggle-target data-toggle-target="#' + groupId + '">',
      '<button type="button" class="filter-group__heading" aria-expanded="true" aria-controls="' + groupId + '">',
      '<div class="filter-group__heading__text">',
      escapeHtml(title),
      '</div>',
      '<span class="filter-group__heading__indicator">',
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation"><path d="m6 9 6 6 6-6"/></svg>',
      '</span>',
      '</button>',
      '</toggle-target>',
      '<div id="' + groupId + '" class="filter-group__items toggle-target">',
      '<div class="toggle-target-container">',
      html,
      '</div>',
      '</div>',
      '</div>',
    ].join('');
  }

  function syncAvailabilityToggle(root, params) {
    var hideUnavailable = isHideUnavailableActive(params);
    var showInput = root.querySelector('[name="' + AVAILABILITY_PARAM + '"][value=""]');
    var hideInput = root.querySelector('[name="' + AVAILABILITY_PARAM + '"][value="1"]');

    if (showInput) showInput.checked = !hideUnavailable;
    if (hideInput) hideInput.checked = hideUnavailable;
  }

  function renderFocusedFilters(root, entries, params) {
    var form = root.querySelector('#CollectionFilterForm');
    var filters = root.querySelector('.filters');
    var toggleButton = root.querySelector('[data-toggle-filters].toggle-btn');
    if (!form || !filters) return;

    var existing = form.querySelector('[data-rg-search-focused-filters]');
    if (existing) existing.remove();
    syncAvailabilityToggle(root, params);

    if (!entries.length) {
      root.classList.remove('rg-search-page--focused-active');
      return;
    }

    root.classList.add('rg-search-page--focused-active');
    filters.classList.remove('mobile-only');
    if (toggleButton) toggleButton.classList.remove('mobile-only');

    var vendorHtml = sortedValues(entries, 'vendor').map(function (vendor) {
      return renderFilterLink('rg_vendor', vendor, vendor, params);
    }).join('');
    var typeHtml = sortedValues(entries, 'product_type').map(function (type) {
      return renderFilterLink('rg_product_type', type, type, params);
    }).join('');
    var clearHtml = params.has(AVAILABILITY_PARAM) || params.has(LEGACY_AVAILABILITY_PARAM) || params.has('rg_vendor') || params.has('rg_product_type')
      ? '<div class="filter-group__clear-row"><a class="filter-group__clear-link" href="' + escapeHtml(clearFocusedFilterUrl()) + '" data-rg-search-focused-filter>Clear focused filters</a></div>'
      : '';

    var wrapper = document.createElement('div');
    wrapper.setAttribute('data-rg-search-focused-filters', '');
    wrapper.innerHTML = [
      clearHtml,
      vendorHtml ? renderFilterGroup('Brand', vendorHtml) : '',
      typeHtml ? renderFilterGroup('Type', typeHtml) : '',
    ].join('');

    form.insertBefore(wrapper, form.firstChild);
  }

  function syncSortLinks(root) {
    var currentParams = new URLSearchParams(window.location.search);
    canonicalizeAvailabilityParams(currentParams);

    root.querySelectorAll('#sort-dropdown-options .link-dropdown__link').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var sortBy = url.searchParams.get('sort_by');
      url.search = '';

      currentParams.forEach(function (value, key) {
        if (key !== 'sort_by') url.searchParams.append(key, value);
      });

      if (sortBy) url.searchParams.set('sort_by', sortBy);
      link.setAttribute('href', url.pathname + url.search);
    });
  }

  function syncPaginationLinks(root) {
    // Shopify's paginate part URLs keep q and native filter params but drop
    // unrecognized ones, so rg_view has to be re-appended for the all-results
    // view to survive pagination clicks.
    root.querySelectorAll('.pagination-row a[href]').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.searchParams.get(VIEW_PARAM) === 'all') return;
      url.searchParams.set(VIEW_PARAM, 'all');
      link.setAttribute('href', url.pathname + url.search);
    });
  }

  function sizedShopifyImageUrl(url, width) {
    var value = String(url || '');
    if (!value || !width) return value;

    if (/[?&]width=\d+/.test(value)) {
      return value.replace(/([?&]width=)\d+/, '$1' + width);
    }

    var sizedFilenamePattern = /_(\d+)x(\d*)?(?=\.[a-z]+(?:\?|$))/i;
    if (sizedFilenamePattern.test(value)) {
      return value.replace(sizedFilenamePattern, '_' + width + 'x');
    }

    if (/cdn\.shopify\.com/.test(value)) {
      return value + (value.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    return value;
  }

  function imageSrcset(url) {
    if (!url) return '';
    return IMAGE_WIDTHS.map(function (width) {
      return sizedShopifyImageUrl(url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function renderImage(entry, imageSizes) {
    if (!entry.image) return '';

    return [
      '<img class="theme-img" src="',
      escapeHtml(sizedShopifyImageUrl(entry.image, 900)),
      '" srcset="',
      escapeHtml(imageSrcset(entry.image)),
      '" sizes="',
      escapeHtml(imageSizes || '50vw'),
      '" alt="" loading="lazy" decoding="async">',
    ].join('');
  }

  function renderSoldOutLabel(entry) {
    if (entry.available) return '';

    return [
      '<div class="product-label-container">',
      '<span class="product-label product-label--sold-out">',
      '<span>Sold out</span>',
      '</span>',
      '</div>',
    ].join('');
  }

  function renderCard(entry, showVendor, imageSizes, displaySpecs) {
    var identifiers = [
      entry.reference_number && 'Ref ' + entry.reference_number,
      entry.serial_number && 'Serial ' + entry.serial_number,
      displaySpecs && displaySpecs.weight && entry.entry_type === 'guitar_listing' && entry.weight_display && 'Weight ' + entry.weight_display,
      displaySpecs && displaySpecs.nutWidth && entry.entry_type === 'guitar_listing' && entry.nut_width_display && 'Nut Width ' + entry.nut_width_display,
    ].filter(Boolean).join(' · ');
    var variantTitle = String(entry.variant_title || '').trim();
    var price = formatPrice(entry.price);

    return [
      '<product-block class="product-block rg-search-page-card',
      entry.entry_type === 'guitar_listing' ? ' product-block--guitar-listing' : '',
      '">',
      '<div class="block-inner">',
      '<div class="block-inner-inner">',
      '<div class="image-cont">',
      '<a class="product-link" href="' + escapeHtml(entry.url) + '" aria-hidden="true" tabindex="-1">',
      '<div class="image-label-wrap">',
      '<div>',
      '<div class="product-block__image product-block__image--primary product-block__image--active">',
      renderImage(entry, imageSizes),
      '</div>',
      '</div>',
      renderSoldOutLabel(entry),
      '</div>',
      '</a>',
      '</div>',
      '<div class="product-block__detail align-ltr-left">',
      '<div class="inner">',
      '<div class="innerer">',
      '<a class="product-link" href="' + escapeHtml(entry.url) + '">',
      showVendor && entry.vendor
        ? '<div class="vendor">' + escapeHtml(entry.vendor) + '</div>'
        : '',
      '<div class="product-block__title">' + escapeHtml(entry.title) + '</div>',
      identifiers
        ? '<div class="product-block__subtitle rg-search-page-card__meta">' + escapeHtml(identifiers) + '</div>'
        : entry.entry_type === 'variant_sku_lookup' && variantTitle && variantTitle !== 'Default Title'
          ? '<div class="product-block__subtitle rg-search-page-card__meta">' + escapeHtml(variantTitle) + '</div>'
          : '',
      price
        ? '<div class="product-price product-price--block"><span class="price"><span class="price__default"><span class="price__current">' + escapeHtml(price) + '</span></span></span></div>'
        : '',
      '</a>',
      '</div>',
      '</div>',
      '</div>',
      '</div>',
      '</div>',
      '</product-block>',
    ].join('');
  }

  function loadSearchIndex(url) {
    if (!url) return Promise.resolve({ entries: [], variantSkuLookups: [] });
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (index) {
        if (
          !index ||
          index.schema_version !== SEARCH_INDEX_SCHEMA_VERSION ||
          !Array.isArray(index.entries)
        ) {
          return { entries: [], variantSkuLookups: [] };
        }
        return {
          entries: index.entries,
          variantSkuLookups: Array.isArray(index.variant_sku_lookups)
            ? index.variant_sku_lookups
            : [],
        };
      });
  }

  function mergeExactSkuResults(ranked, skuMatches) {
    if (!skuMatches.length) return ranked;

    var seen = new Set();
    var merged = [];

    skuMatches.concat(ranked).forEach(function (entry) {
      var key = entry.url || '';
      if (!key || seen.has(key)) return;
      seen.add(key);
      merged.push(entry);
    });

    return merged;
  }

  function renderPageLane(container, query) {
    container.innerHTML = [
      '<a class="rg-search-page__pages-link" href="/search?q=',
      encodeURIComponent(query),
      '&type=page">',
      'Search pages and articles for <strong>',
      escapeHtml(query),
      '</strong>',
      '</a>',
    ].join('');
  }

  function specIntent(query) {
    return window.RGSearchCore.parseSpecFilteredQuery
      ? window.RGSearchCore.parseSpecFilteredQuery(query)
      : null;
  }

  function specConstraintLabel(parsed) {
    return parsed && Array.isArray(parsed.labels) && parsed.labels.length
      ? parsed.labels.join(' ')
      : '';
  }

  function resultSummaryText(count, query, constraintLabel) {
    return [
      count,
      ' focused result',
      count === 1 ? '' : 's',
      ' for "',
      query,
      '"',
      constraintLabel ? ' ' + constraintLabel : '',
    ].join('');
  }

  function noResultsSummaryText(query, constraintLabel) {
    return [
      'No focused product matches for "',
      query,
      '"',
      constraintLabel ? ' ' + constraintLabel : '',
      '.',
    ].join('');
  }

  ready(function () {
    var root = document.querySelector('[data-rg-search-page]');
    if (!root || !window.RGSearchCore) return;

    var cachedIndex = null;
    var scheduled = false;
    var showVendor = root.dataset.showVendor === 'true';
    var imageSizes = root.dataset.imageSizes || '';
    var focusedCache = { query: null, entries: null };

    function focusedEntriesFor(indexData, query) {
      if (focusedCache.query === query && focusedCache.entries) return focusedCache.entries;
      var ranked = window.RGSearchCore.rankSearchEntries(indexData.entries || [], query, { limit: 120 });
      var skuMatches = window.RGSearchCore.findExactVariantSkuLookupMatches(indexData.variantSkuLookups || [], query);
      focusedCache = { query: query, entries: mergeExactSkuResults(ranked, skuMatches) };
      return focusedCache.entries;
    }

    function syncFocusedParamInputs(params) {
      // ajaxLoadForm rebuilds the URL from form inputs only, so any RG param
      // not mirrored as a hidden input is silently dropped when the
      // availability toggle or a native filter checkbox changes.
      var form = root.querySelector('#CollectionFilterForm');
      if (!form) return;

      var names = isAllView(params) ? [VIEW_PARAM] : ['rg_vendor', 'rg_product_type'];
      var desired = [];
      names.forEach(function (name) {
        activeParamValues(params, name).forEach(function (value) {
          desired.push({ name: name, value: value });
        });
      });

      var existing = Array.prototype.slice.call(form.querySelectorAll('input[data-rg-search-param]'));
      var matches = existing.length === desired.length && desired.every(function (pair, i) {
        return existing[i].name === pair.name && existing[i].value === pair.value;
      });
      if (matches) return;

      existing.forEach(function (input) {
        input.remove();
      });
      desired.forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = pair.name;
        input.value = pair.value;
        input.setAttribute('data-rg-search-param', '');
        form.appendChild(input);
      });
    }

    function syncViewNote(params, query, focusedEntries) {
      var note = root.querySelector('[data-rg-search-view-note]');
      var show = isAllView(params) && query && focusedEntries.length > 0;

      if (!show) {
        if (note) note.remove();
        return;
      }
      if (note) return;

      var enhanced = root.querySelector('[data-rg-search-enhanced]');
      if (!enhanced || !enhanced.parentNode) return;

      var nativeCount = nativeResultCount(root);
      note = document.createElement('div');
      note.className = 'rg-search-view-note';
      note.setAttribute('data-rg-search-view-note', '');
      note.innerHTML = [
        'Showing all ',
        nativeCount > 0 ? nativeCount + ' ' : '',
        'result',
        nativeCount === 1 ? '' : 's',
        ' for "',
        escapeHtml(query),
        '". <a href="',
        escapeHtml(focusedViewUrl()),
        '">Show top matches</a>',
      ].join('');
      enhanced.parentNode.insertBefore(note, enhanced.parentNode.firstChild);
    }

    function render(params, query, focusedEntries) {
      var sortBy = params.get('sort_by') || 'relevance';
      var parsedSpecIntent = specIntent(query);
      var constraintLabel = specConstraintLabel(parsedSpecIntent);
      var displaySpecs = parsedSpecIntent && parsedSpecIntent.displaySpecs
        ? parsedSpecIntent.displaySpecs
        : { weight: false, nutWidth: false };

      var enhanced = root.querySelector('[data-rg-search-enhanced]');
      var nativeResults = root.querySelector('[data-rg-native-results]');
      var grid = root.querySelector('[data-rg-search-grid]');
      var summary = root.querySelector('[data-rg-search-page-summary]');
      var pages = root.querySelector('[data-rg-search-pages]');
      var renderKey = params.toString();

      if (!enhanced || !nativeResults || !grid || !summary) return;
      if (enhanced.dataset.rgSearchRenderedFor === renderKey) return;

      var focused = filteredFocusedResults(focusedEntries, params);
      var sorted = sortFocusedResults(focused, sortBy);

      enhanced.dataset.rgSearchRenderedFor = renderKey;
      nativeResults.hidden = true;
      enhanced.hidden = false;
      root.classList.add('rg-search-page--focused-visible');
      syncViewNote(params, query, focusedEntries);
      syncFocusedParamInputs(params);
      syncSortLinks(root);
      renderFocusedFilters(root, focusedEntries, params);

      var summaryText;
      if (sorted.length) {
        grid.hidden = false;
        grid.innerHTML = sorted.map(function (entry) {
          return renderCard(entry, showVendor, imageSizes, displaySpecs);
        }).join('');
        summaryText = resultSummaryText(sorted.length, query, constraintLabel);
      } else {
        grid.hidden = true;
        grid.innerHTML = '';
        summaryText = noResultsSummaryText(query, constraintLabel);
      }

      var nativeCount = nativeResultCount(root);
      if (nativeCount > 0) {
        var separator = summaryText.slice(-1) === '.' ? ' ' : ' · ';
        summary.innerHTML = escapeHtml(summaryText) + separator + showAllLinkHtml(nativeCount);
      } else {
        summary.textContent = summaryText;
      }

      var countText = sorted.length + ' result' + (sorted.length === 1 ? '' : 's');
      root.querySelectorAll('[data-rg-search-count]').forEach(function (el) {
        el.textContent = countText;
      });
      var resultsMessage = root.querySelector('[data-results-message]');
      if (resultsMessage) resultsMessage.textContent = summaryText;

      if (pages) renderPageLane(pages, query);
    }

    function renderDormant(params, query, focusedEntries) {
      // Native view: rg_view=all, or no focused matches for the query.
      // Leave the server-rendered grid, filters, and pagination alone so
      // they behave stock; just make sure no focused-layer artifacts linger.
      var enhanced = root.querySelector('[data-rg-search-enhanced]');
      var nativeResults = root.querySelector('[data-rg-native-results]');
      if (!enhanced || !nativeResults) return;

      root.classList.remove('rg-search-page--focused-visible');
      root.classList.remove('rg-search-page--focused-active');
      enhanced.hidden = true;
      delete enhanced.dataset.rgSearchRenderedFor;
      nativeResults.hidden = false;

      var focusedFilters = root.querySelector('[data-rg-search-focused-filters]');
      if (focusedFilters) focusedFilters.remove();

      syncFocusedParamInputs(params);
      syncSortLinks(root);
      if (isAllView(params)) syncPaginationLinks(root);
      syncViewNote(params, query, focusedEntries);
    }

    function update(indexData) {
      var params = new URLSearchParams(window.location.search);
      var query = (params.get('q') || root.dataset.searchQuery || '').trim();
      if (!query) return;

      var focusedEntries = focusedEntriesFor(indexData, query);
      if (isAllView(params) || !focusedEntries.length) {
        renderDormant(params, query, focusedEntries);
      } else {
        render(params, query, focusedEntries);
      }
    }

    function scheduleRender() {
      if (!cachedIndex || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        update(cachedIndex);
      });
    }

    loadSearchIndex(root.dataset.searchIndexUrl)
      .then(function (indexData) {
        cachedIndex = indexData;
        update(cachedIndex);
        new MutationObserver(scheduleRender).observe(root, {
          childList: true,
          subtree: true,
        });
      })
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.warn('[rg-search results]', error);
      });

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-rg-search-focused-filter]');
      if (!link) return;
      event.preventDefault();
      window.history.pushState({ path: link.href }, '', link.href);
      if (cachedIndex) update(cachedIndex);
    });

    window.addEventListener('popstate', function () {
      if (cachedIndex) update(cachedIndex);
    });
  });
})();
